import { HSpacer, Text } from '@/components/DesignSystem';
import { useSnackbar } from '@/providers/GlobalSnackbarProvider';
import ContentCut from '@mui/icons-material/ContentCut';
import { Stack, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface LoyaltySkuBadgeProps {
  sku: string;
}

export const LoyaltySkuBadge = ({ sku }: LoyaltySkuBadgeProps) => {
  const { t } = useTranslation();
  const { openSnackbar } = useSnackbar();
  const theme = useTheme();

  const handleCopyToClipboard = (e: React.MouseEvent) => {
    e.stopPropagation();
    void navigator.clipboard.writeText(sku);
    openSnackbar(t($ => $.common.actions.copied));
  };

  return (
    <Stack
      alignItems="center"
      direction="row"
      onClick={handleCopyToClipboard}
      px="24px"
      py="12px"
      sx={{
        borderRadius: '100px',
        border: '1px dashed #909090',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
      }}
      width="fit-content"
    >
      <ContentCut
        sx={{
          color: theme.palette.text.secondary,
          height: '16px',
          width: '16px',
        }}
      />
      <HSpacer size="3" />
      <Text
        category="label-medium"
        sx={{ color: theme.palette.text.secondary }}
        whiteSpace="nowrap"
      >
        {t($ => $.shared.loyaltySku.label, { sku })}
      </Text>
    </Stack>
  );
};
